export default __webpack_public_path__ + "e1d1f1331cff29e8048d3cac42f43e7b.png";